import api from '@/api';

const defaultState = {
  eventLogs: [],
  isShowingInfoBadge: true,
};

const actions = {
  getGiveUp({ commit }) {
    return new Promise((resolve, reject) => {
      api.eventLogs
        .getEventLogs('give up')
        .then((res) => {
          console.log(`EventLogs`, res);
          commit(
            'eventLogsLoaded',
            res.sort((a, b) => {
              if (a.startDate === undefined) {
                return -1;
              } else if (a.startDate < b.startDate) {
                return 1;
              } else if (a.startDate > b.startDate) {
                return -1;
              } else {
                return 0;
              }
            }),
          );
          resolve();
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  hideInfoBadge({ commit }) {
    commit('setInfoBadge', false);
  },
};

const mutations = {
  eventLogsLoaded: (state, eventLogs) => {
    state.eventLogs = eventLogs;
  },
  setInfoBadge: (state, value) => {
    state.isShowingInfoBadge = value;
  },
};

const getters = {
  eventLogs: (state) => state.eventLogs,
  isShowingInfoBadge: (state) => state.isShowingInfoBadge,
};

export default {
  namespaced: true,
  state: defaultState,
  getters,
  actions,
  mutations,
};
